





















import Vue from 'vue'
import { Amiibo, getCachedCategories } from '../service'

/**
 * Footer.
 *
 * @remarks
 * Shows a sitemap with categories provided by Amiibo servise.
 */
export default Vue.extend({
  name: 'MyFooter',
  data () {
    return {
      categories: []
    }
  },
  created () {
    getCachedCategories()
      .then(
        (data) => {
          this.categories = data.amiibo
        }
      )
      .catch(
        function (err) {
          console.error('Fetch error', err)
        }
      )
  }
})
